/* MILES Insights — radar, briefing filters, story tilt, risk compass.
   Progressive enhancement: without JS the chips are plain tag links, every
   story is visible and the first compass panel is shown. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function countUp(el) {
    var target = parseInt(el.getAttribute('data-ins-count'), 10);
    if (!target || reduce) return;
    var start = null;
    var dur = 1200;
    el.textContent = '0';
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      el.textContent = String(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  ready(function () {
    /* Legacy .miles-reveal blocks (Instagram section) were revealed by the old
       insights hero script, which no longer loads on this page. */
    var legacy = document.querySelectorAll('.miles-reveal:not(.is-visible)');
    if (legacy.length) {
      if (reduce || typeof IntersectionObserver === 'undefined') {
        legacy.forEach(function (el) { el.classList.add('is-visible'); });
      } else {
        var lio = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            lio.unobserve(entry.target);
          });
        }, { threshold: 0.08 });
        legacy.forEach(function (el) { lio.observe(el); });
        /* Safety net: never leave content hidden after a fast scroll */
        window.addEventListener('load', function () {
          window.setTimeout(function () {
            legacy.forEach(function (el) {
              if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-visible');
            });
          }, 300);
        });
        document.addEventListener('scroll', function () {
          legacy.forEach(function (el) {
            if (!el.classList.contains('is-visible') && el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('is-visible');
          });
        }, { passive: true, capture: true });
      }
    }

    document.querySelectorAll('[data-ins-count]').forEach(function (el) {
      window.setTimeout(function () { countUp(el); }, 500);
    });

    /* ---------- Briefing feed ---------- */
    var feed = document.querySelector('[data-ins-feed]');
    var state = { topic: 'all', topicLabel: '', query: '' };

    function applyFilter(scroll) {
      if (!feed) return;
      var cards = Array.prototype.slice.call(feed.querySelectorAll('[data-ins-card]'));
      var ask = feed.querySelector('[data-ins-ask]');
      var empty = feed.querySelector('[data-ins-empty]');
      var status = feed.querySelector('[data-ins-status]');
      var q = state.query.trim().toLowerCase();
      var shown = 0;

      cards.forEach(function (card) {
        var tags = (' ' + (card.getAttribute('data-tags') || '') + ' ');
        var text = card.getAttribute('data-text') || '';
        var match = (state.topic === 'all' || tags.indexOf(' ' + state.topic + ' ') > -1) && (!q || text.indexOf(q) > -1);
        if (match) {
          shown++;
          if (card.hidden || card.classList.contains('is-out')) {
            card.hidden = false;
            card.classList.remove('is-out');
            card.classList.remove('is-in');
            void card.offsetWidth;
            card.classList.add('is-in');
          }
        } else if (!card.hidden) {
          card.classList.add('is-out');
          window.setTimeout(function () {
            if (card.classList.contains('is-out')) card.hidden = true;
          }, reduce ? 0 : 320);
        }
      });

      if (ask) ask.hidden = shown === 0;
      if (empty) {
        empty.hidden = shown !== 0;
        var label = empty.querySelector('[data-ins-empty-topic]');
        if (label) label.textContent = q ? '“' + state.query.trim() + '”' : (state.topicLabel || 'this topic');
      }
      if (status) {
        status.textContent = shown === cards.length && !q && state.topic === 'all'
          ? cards.length + (cards.length === 1 ? ' story' : ' stories')
          : 'Showing ' + shown + ' of ' + cards.length;
      }
      if (scroll) feed.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    /* Chips + sliding pill */
    var chipsWrap = feed && feed.querySelector('[data-ins-chips]');
    var pill = chipsWrap && chipsWrap.querySelector('.lx-feed__pill');

    function movePill() {
      if (!chipsWrap || !pill) return;
      var active = chipsWrap.querySelector('.lx-fchip.is-active');
      if (!active) return;
      pill.style.setProperty('--px', active.offsetLeft + 'px');
      pill.style.setProperty('--pw', active.offsetWidth + 'px');
    }

    function setTopic(handle, label, scroll) {
      state.topic = handle || 'all';
      state.topicLabel = label || '';
      if (chipsWrap) {
        chipsWrap.querySelectorAll('.lx-fchip').forEach(function (chip) {
          var on = chip.getAttribute('data-ins-filter') === state.topic;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on && chip.scrollIntoView && chipsWrap.scrollWidth > chipsWrap.clientWidth) {
            chipsWrap.scrollTo({ left: chip.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' });
          }
        });
        /* A radar topic with no chip (no stories yet) leaves "All" unhighlighted */
        if (!chipsWrap.querySelector('.lx-fchip.is-active')) {
          pill && pill.style.setProperty('--pw', '0px');
        } else {
          movePill();
        }
      }
      applyFilter(scroll);
    }

    if (chipsWrap) {
      chipsWrap.addEventListener('click', function (e) {
        var chip = e.target.closest('.lx-fchip');
        if (!chip) return;
        e.preventDefault();
        setTopic(chip.getAttribute('data-ins-filter'), chip.textContent.trim().replace(/\s+\d+$/, ''), false);
      });
      window.addEventListener('resize', movePill);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(movePill);
      movePill();
    }

    /* Search */
    var search = feed && feed.querySelector('[data-ins-search]');
    if (search) {
      var t = null;
      search.addEventListener('input', function () {
        window.clearTimeout(t);
        t = window.setTimeout(function () {
          state.query = search.value;
          applyFilter(false);
        }, 120);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== '/' || e.target.closest('input, textarea, select, [contenteditable]')) return;
        e.preventDefault();
        search.focus();
      });
    }

    /* Reset */
    var reset = feed && feed.querySelector('[data-ins-reset]');
    if (reset) {
      reset.addEventListener('click', function () {
        if (search) search.value = '';
        state.query = '';
        setTopic('all', '', false);
      });
    }

    /* Radar signals filter the briefing */
    document.querySelectorAll('[data-ins-topic]').forEach(function (blip) {
      blip.addEventListener('click', function () {
        var label = (blip.getAttribute('aria-label') || '').split(':')[0];
        setTopic(blip.getAttribute('data-ins-topic'), label, true);
      });
    });

    /* Deep link: ?topic=property-fire */
    var params = new URLSearchParams(window.location.search);
    if (params.get('topic')) setTopic(params.get('topic'), params.get('topic').replace(/-/g, ' '), false);
    else applyFilter(false);

    /* Story tilt */
    if (finePointer && !reduce && feed) {
      feed.querySelectorAll('[data-ins-card], [data-ins-ask]').forEach(function (card) {
        var raf = null;
        card.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            card.style.setProperty('--ry', (x * 5).toFixed(2) + 'deg');
            card.style.setProperty('--rx', (y * -4).toFixed(2) + 'deg');
          });
        });
        card.addEventListener('pointerleave', function () {
          if (raf) cancelAnimationFrame(raf);
          card.style.setProperty('--rx', '0deg');
          card.style.setProperty('--ry', '0deg');
        });
      });
    }

    /* ---------- Risk Compass ---------- */
    var compass = document.querySelector('[data-ins-compass]');
    if (compass) {
      var tabs = Array.prototype.slice.call(compass.querySelectorAll('[data-compass-tab]'));
      var panels = Array.prototype.slice.call(compass.querySelectorAll('[data-compass-panel]'));
      var needle = compass.querySelector('[data-compass-needle]');

      function select(i, focus) {
        tabs.forEach(function (tab, n) {
          var on = n === i;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focus) tab.focus();
        });
        panels.forEach(function (panel, n) { panel.hidden = n !== i; });
        if (needle) needle.style.setProperty('--needle', (i * (360 / Math.max(tabs.length, 1)) + 20) + 'deg');
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); select(n, true); }
        });
      });
      select(0, false);
    }
  });
})();
